import extendedContractsDictionary from '@widgets/extended-contracts/i18n/ru/extended-contracts.dic.json';

import agentContractDictionary from '@entities/agent-contract/i18n/ru/agent-contract.dic.json';

export const agentContract = {
  AGENT_CONTRACT: agentContractDictionary,
  EXTENDED_CONTRACTS: extendedContractsDictionary,
};

export const agentContractNamespaces = Object.keys(agentContract);
